// extracted by mini-css-extract-plugin
module.exports = {"hr":"hr_hr__3tGH6"};